export default "__VITE_ASSET__DLi2uqJk__"